<template>
  <h1 style="height: 100%; display: flex; align-items: center; justify-content: center">页面没有找到！</h1>
</template>

<script>
  export default {
    name: 'PageNotFound'
  }
</script>

<style scoped>

</style>
